import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loginActions } from './action/loginAction';
import { withTranslation } from 'react-i18next';
import { appVariables } from './helpers/appVariables';
import { alertActions } from './action/AlertAction';
import Header from './Header/Header';
// import countrycode from './Pages/Home/countrycode.json';
import { history } from './helpers/history';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import { commonClass } from './helpers/commonClass';

class ForgotPasswordMobNo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileNo: '', otp: '', password: '',
            Countrydetails: [], Selcountry: {},
            showpwd: false, TermsAndCond: true,
            Countryfilter: '', Default: {},
            UserCountry: localStorage.getItem('cloc') ? JSON.parse(localStorage.getItem('cloc')) : {},
            userid: "",
            SwitchControl: false,
            ShowErrorMsg: ""
        }
        this.GetOtp = this.GetOtp.bind(this);
        this.props.logout(this.props.user.mobileNo, 1);
    }
    handleInputChange(e) {
        this.setState({ ShowErrorMsg: "" })
        const regex = /^[0-9\b]+$/;
        if (regex.test(e.target.value) || e.target.value == '') {
            this.setState({ [e.target.name]: e.target.value });
        }
    }
    toggleCountry = () => {
        window.setCountryToggle();
    }
    countryChange = (data) => {
        this.setState({ Selcountry: data, mobileNo: '' });
        window.setCountryToggle();
        this.state.Countryfilter = ''
    }

    // GetOtp = (e) => {
    //     e.preventDefault();
    //     if (this.state.mobileNo && this.state.mobileNo != "") {
    //         if (this.state.mobileNo.length <= this.state.Selcountry.mobNolength && this.state.mobileNo.length >= this.state.Selcountry.mobNoMinlength) {
    //             this.props.Otpgen(this.state.mobileNo, appVariables.OTP.ForgetPassword, this.props.i18n.language, this.props.user.loginKey, this.state.Selcountry.flag);
    //         }
    //         else { this.showMsg('lblValidMobileNo', 1); }
    //     }
    //     else {
    //         this.showMsg('lblentermobileNo', 1);
    //     }
    // }
    GetOtp = (e) => {
        e.preventDefault();
        const { mobileNo, Selcountry } = this.state;
        const { i18n, user } = this.props;
        let validationflag = true
        // Check if mobile number is entered
        if (!mobileNo || mobileNo.trim() === "") {
            this.showMsg('lblentermobileNo', 1);
            validationflag = false
        }

        // Check if mobile number length is valid
        const mobLength = mobileNo.length;
        const { mobNolength, mobNoMinlength, flag } = Selcountry;

        if ((mobLength < mobNoMinlength || mobLength > mobNolength) && validationflag) {
            this.showMsg('lblValidMobileNo', 1);
            validationflag = false;
        }
        if (validationflag) {
            // All validations passed, trigger OTP
            this.props.Otpgen(
                mobileNo,
                appVariables.OTP.ForgetPassword,
                i18n.language,
                user.loginKey,
                flag
            );
        }
    };



    static getDerivedStateFromProps(props, state) {
        return { otp: props.otp };
    };
    componentDidUpdate(prevState, prevProps) {
        // if (this.props.otp && this.props.otp.otp && (prevProps.otp == null || prevProps.otp.mobileNo != this.props.otp.mobileNo)) {
        //     this.showMsg(this.props.otp.otp);
        // }
    }
    componentDidMount(prevState, prevProps) {
        if (window.LoginOverlay) {
            window.LoginOverlay()
        }
        this.GetCountryList()
        setTimeout(() => {
            this.GetUserCountry()
        }, 300);
    }
    showMsg = (msg, setflag) => {
        if (setflag == 1) {
            let form_string = this.props.t(msg);
            this.setState({ ShowErrorMsg: form_string })
        }
        else {
            this.props.alertError(this.props.t(msg));
        }
    }

    handleChange = (e) => {
        e.preventDefault()
        let name = e.target.name;
        this.setState({ [name]: e.target.value })
        this.state.Countryfilter = e.target.value;
    }

    GetCountryList = () => {
        let new_Version = 0;
        let Version_old = localStorage.getItem('countryver');
        if (this.props.appvariables.bVersion) {
            let totalversion = this.props.appvariables.bVersion.split("~")
            if (totalversion.length > 0) {
                new_Version = totalversion[3];
            }
        }
        if (Version_old != new_Version) {
            commonClass.GetCountry(new_Version)
                .then(response =>
                    response.json()
                )
                .then(data => {
                    localStorage.setItem('countryver', new_Version);
                    localStorage.setItem('countrylst', JSON.stringify(data));
                    this.setState({ Countrydetails: data })
                    // this.setState({ Selcountry: data.default })
                    this.setState({ Default: data.default })
                });
        }
        else {
            let CountryList = JSON.parse(localStorage.getItem('countrylst')); // get from localstorage for countrylist
            this.setState({ Countrydetails: CountryList })
            // this.setState({ Selcountry: CountryList.default })
            this.setState({ Default: CountryList.default })
        }
    }

    GetUserCountry = () => {
        let mythis = this;
        try {
            commonClass.GetUserCountry()
                .then(response =>
                    response.json()
                )
                .then(data => {
                    if (data) {
                        let LoadCountry = this.state.Countrydetails.other.filter(Fobj => Fobj.isocode2 == data.country)
                        if (LoadCountry && LoadCountry.length > 0) {
                            this.setState({ Selcountry: LoadCountry[0] });
                        }
                        else {
                            this.setState({ Selcountry: this.state.Default })
                        }
                        localStorage.setItem('cloc', JSON.stringify(data));
                    }
                    else {
                        this.setState({ Selcountry: this.state.Default })
                    }
                }).catch(function (err) {
                    mythis.setState({ Selcountry: mythis.state.Default })
                });
        } catch (error) {
            mythis.setState({ Selcountry: mythis.state.Default })
        }
    }

    render() {
        const { t } = this.props;
        let IsError = this.state.ShowErrorMsg.length > 0;
        return (
            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    <title>Gulf Ticket - Login</title>
                    <meta name="description" content="Securely Access Your Gulf Ticket Account: Login Now" />
                    <meta name="keywords" content="Gulf Ticket, online raffle draw, Biggest Online Draw" />

                    <meta property="og:title" content="Gulf Ticket - Login" />
                    <meta property="og:site_name" content="Gulf Ticket" />
                    <meta property="og:url" content="https://gulfticket.com" />
                    <meta property="og:description" content="Securely Access Your Gulf Ticket Account: Login Now" />
                    <meta property="og:type" content="website" />
                    <meta property="og:image" content="https://gulfticket.com/assets/img/logo.png" />
                </Helmet>}
                <div class="signInBox" style={{ display: "block" }}>
                    <div class="signInBoxWrap">
                        <div class="signBoxLft">
                            <img src="./assets/img/sign-lft.png" />
                        </div>
                        <div class="signBoxRht">
                            <div class="userContent">
                                <a class="lightBoxClose" ><img src="./assets/img/icons/pop_close.png" /></a>
                                <h1>{t('lblforgotPwd')}</h1>
                                <p>{t('lbldonworry')}<br /> {t('lblrecoverpass')}</p>
                                <form class="register-form paddTop-20" onSubmit={this.GetOtp}>
                                    <div class="formCont">
                                        <label>{t('lblMobileNo')} <sup>*</sup></label>
                                        <div className={`countryCodes ${IsError ? "errorBorder bor-right-none" : ""}`}>
                                            <>
                                                {this.state.Selcountry && this.state.Selcountry.flag &&
                                                    // style={{ width: '10px' }}
                                                    <a className="countryImg" onClick={() => this.toggleCountry()}>
                                                        <img src={`${process.env.REACT_APP_CDN_URL}/assets/flags/${this.state.Selcountry.flag}.png?v0`} alt={this.state.Selcountry.Ccname} />
                                                        <small>{this.state.Selcountry.code}</small>
                                                    </a>}

                                                <ul id='selContry' className="selContry scrollbar" style={{ display: "none" }}>
                                                    <li><input style={{ padding: "5px 10px", margin: "5px", height: "35px" }} type="text" value={this.state.Countryfilter} name="Countryfilter" placeholder="Search" onChange={(e) => { this.handleChange(e) }} /></li>
                                                    {this.state.Countrydetails && this.state.Countrydetails.other && this.state.Countrydetails.other.filter(country =>
                                                        (country.Countryname.includes(this.state.Countryfilter.toUpperCase()) || country.flag.includes(this.state.Countryfilter))).map((data, inx) =>
                                                            <li key={`n_${inx}`}><a onClick={() => this.countryChange(data)}><img src={`${process.env.REACT_APP_CDN_URL}/assets/flags/${data.flag}.png?v0`} alt='Show Flag Icon' />{data.code}</a></li>
                                                        )}
                                                </ul>
                                            </>
                                        </div>
                                        {this.state.Selcountry && <input type='text' name='mobileNo' placeholder={`${t('lblMobileNo')}*`} value={this.state.mobileNo} onChange={this.handleInputChange.bind(this)}
                                            maxLength={this.state.Selcountry.mobNolength} autocomplete="off" className={`inputMobile ${IsError ? "errorBorder" : ""}`} ></input>}
                                        {IsError && <div class="errorTxt">{this.state.ShowErrorMsg}</div>}
                                    </div>
                                    <div class="formCont">
                                        <button type="submit" >{t('lblSubmit')}</button>
                                    </div>
                                </form>
                                <span class="agree"><a onClick={() => { this.props.getflag(0) }} target="_blank">{t('lblback')} {t('lblLogin')}</a></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="overlayLogin" style={{ display: "block" }}></div>
            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, otp, appvariables } = state.loginReducer;
    return { user, otp, appvariables };
}
const mapActionToProps = {
    login: loginActions.login,
    setPage: loginActions.setPage,
    Otpgen: loginActions.lfnotpgen,
    alertError: alertActions.error,
    logout: loginActions.logout,
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(ForgotPasswordMobNo))